import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/ltx/phase-ii/imaging-procedures-ii/angiographyIndirectPortography";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	angiographyIndirectPortography: {
		id: "form.angiography_indirect_portography",
		defaultMessage: "Angiographia / Indirekt portographia"
	},
	result: {
		id: "form.angiography_indirect_portography.result",
		defaultMessage: "Eltérés"
	},
	comment: {
		id: "form.angiography_indirect_portography.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: { [key: string]: FieldData } = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: resultMessages } }
	},
	comment: {
		type: "field",
		path: ["resultComment"],
		label: messages.comment,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.result }] },
		{ columns: [{ width: 12, field: fields.comment }] }
	]
};

export const node: LeafNode = {
	id: "angiographyIndirectPortography",
	value: {
		title: messages.angiographyIndirectPortography,
		validator,
		fieldset,
		isImportant: true
	}
};
